import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import { alpha, useTheme } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import { CATEGORY_ICON } from "./search-dialog-constants";

export const SearchPlaceholder = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        mt: 6,
        mb: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          backgroundColor: alpha(theme.palette.primary.main, 0.08),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <SvgIcon sx={{ fontSize: 32 }}>
          <FontAwesomeIcon icon={faMagnifyingGlass} />
        </SvgIcon>
      </Box>

      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h6" fontWeight={600}>
          {t("search.placeholderTitle")}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {t("search.placeholderSubtitle")}
        </Typography>
      </Box>

      <Stack
        direction="row"
        flexWrap="wrap"
        gap={1}
        justifyContent="center"
        sx={{ mt: 1 }}
      >
        {Object.entries(CATEGORY_ICON).map(([label, icon]) => (
          <Chip
            key={label}
            label={t(`search.types.${label}`, { defaultValue: label })}
            size="small"
            variant="outlined"
          />
        ))}
      </Stack>
    </Box>
  );
};
